// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.AbstractClientRequestContext
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class AbstractClientRequestContextBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createAbstractClientRequestContextBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.AbstractClientRequestContext";
  }
  initFromJson(json, deserializeContext) {
    this.initAbstractClientRequestContext(TSOGUtils.decodeObject(json.historicalPointInTime, HistoricalPointInTime, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "historicalPointInTime")));
  }
  initAbstractClientRequestContext(historicalPointInTime) {
    this.initKendoObservableObjectProxy();
    this._historicalPointInTime = historicalPointInTime;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._historicalPointInTime != null) {
      retVal["historicalPointInTime"] = TSOGUtils.toTSOGNativeObject(this._historicalPointInTime, serializeContext);
    }
    return retVal;
  }
  get historicalPointInTime() {
    return this._historicalPointInTime;
  }
  set historicalPointInTime(value) {
    this._historicalPointInTime = value;
  }
}
//# sourceMappingURL=AbstractClientRequestContextBase.js.map
